export const DEFAULT_TEXT_COLOR = '#0f172a'

export const TEXT_COLOR_STORAGE_KEY = 'char-page-text-color'
export const CUSTOM_TEXT_COLORS_STORAGE_KEY = 'char-page-custom-text-colors'
export const MAX_CUSTOM_TEXT_COLORS = 8

// Google Sheets theme palette: 8 rows × 10 columns (grayscale + 9 hue columns).
// Hex values from the standard Google Docs/Sheets/Slides theme (kierandixon.com).
export const SHEETS_THEME_GRID = [
  ['#000000', '#434343', '#666666', '#999999', '#b7b7b7', '#cccccc', '#d9d9d9', '#efefef', '#f3f3f3', '#ffffff'],
  ['#980000', '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#4a86e8', '#0000ff', '#9900ff', '#ff00ff'],
  ['#e6b8af', '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#c9daf8', '#cfe2f3', '#d9d2e9', '#ead1dc'],
  ['#dd7e6b', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#a4c2f4', '#9fc5e8', '#b4a7d6', '#d5a6bd'],
  ['#cc4125', '#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6d9eeb', '#6fa8dc', '#8e7cc3', '#c27ba0'],
  ['#a61c00', '#cc0000', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3c78d8', '#3d85c6', '#674ea7', '#a64d79'],
  ['#85200c', '#990000', '#b45f06', '#bf9000', '#38761d', '#134f5c', '#1155cc', '#0b5394', '#351c75', '#741b47'],
  ['#5b0f00', '#660000', '#783f04', '#7f6000', '#274e13', '#0c343d', '#1c4587', '#073763', '#20124d', '#4c1130'],
]

export const SHEETS_THEME_LABELS = [
  ['black', 'dark grey 4', 'dark grey 3', 'dark grey 2', 'dark grey 1', 'grey', 'light grey 1', 'light grey 2', 'light grey 3', 'white'],
  ['red berry', 'red', 'orange', 'yellow', 'green', 'cyan', 'cornflower blue', 'blue', 'purple', 'magenta'],
  ['light red berry 3', 'light red 3', 'light orange 3', 'light yellow 3', 'light green 3', 'light cyan 3', 'light cornflower blue 3', 'light blue 3', 'light purple 3', 'light magenta 3'],
  ['light red berry 2', 'light red 2', 'light orange 2', 'light yellow 2', 'light green 2', 'light cyan 2', 'light cornflower blue 2', 'light blue 2', 'light purple 2', 'light magenta 2'],
  ['light red berry 1', 'light red 1', 'light orange 1', 'light yellow 1', 'light green 1', 'light cyan 1', 'light cornflower blue 1', 'light blue 1', 'light purple 1', 'light magenta 1'],
  ['dark red berry 1', 'dark red 1', 'dark orange 1', 'dark yellow 1', 'dark green 1', 'dark cyan 1', 'dark cornflower blue 1', 'dark blue 1', 'dark purple 1', 'dark magenta 1'],
  ['dark red berry 2', 'dark red 2', 'dark orange 2', 'dark yellow 2', 'dark green 2', 'dark cyan 2', 'dark cornflower blue 2', 'dark blue 2', 'dark purple 2', 'dark magenta 2'],
  ['dark red berry 3', 'dark red 3', 'dark orange 3', 'dark yellow 3', 'dark green 3', 'dark cyan 3', 'dark cornflower blue 3', 'dark blue 3', 'dark purple 3', 'dark magenta 3'],
]

// Google Sheets "Standard" text colors (larger swatches below the theme grid).
export const SHEETS_STANDARD_COLORS = [
  { label: 'Black', value: '#000000' },
  { label: 'White', value: '#ffffff' },
  { label: 'Blue', value: '#4285f4' },
  { label: 'Red', value: '#ea4335' },
  { label: 'Yellow', value: '#fbbc04' },
  { label: 'Green', value: '#34a853' },
  { label: 'Orange', value: '#ff6d01' },
  { label: 'Teal', value: '#46bdc6' },
]

export function normalizeHex(hex) {
  if (!hex || typeof hex !== 'string') return null
  const value = hex.trim().toLowerCase()
  if (/^#[0-9a-f]{6}$/.test(value)) return value
  if (/^#[0-9a-f]{3}$/.test(value)) {
    return `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`
  }
  return null
}

export function isLightColor(hex) {
  const normalized = normalizeHex(hex)
  if (!normalized) return false
  const r = parseInt(normalized.slice(1, 3), 16)
  const g = parseInt(normalized.slice(3, 5), 16)
  const b = parseInt(normalized.slice(5, 7), 16)
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.62
}

export function loadCustomTextColors() {
  try {
    const raw = localStorage.getItem(CUSTOM_TEXT_COLORS_STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.map(normalizeHex).filter(Boolean).slice(0, MAX_CUSTOM_TEXT_COLORS)
  } catch {
    return []
  }
}

export function saveCustomTextColors(colors) {
  const normalized = colors.map(normalizeHex).filter(Boolean).slice(0, MAX_CUSTOM_TEXT_COLORS)
  localStorage.setItem(CUSTOM_TEXT_COLORS_STORAGE_KEY, JSON.stringify(normalized))
  return normalized
}

export function allPresetColors() {
  const theme = SHEETS_THEME_GRID.flat()
  const standard = SHEETS_STANDARD_COLORS.map((c) => c.value)
  return [...theme, ...standard]
}
